<!--
 * @Author: your name
 * @Date: 2020-12-14 15:08:24
 * @LastEditTime: 2020-12-14 15:54:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/components/creditCardInput/index.vue
-->
<style scoped lang="sass">
.credit_card_input

</style>

<template lang="pug">
.credit_card_input
  input-field(
    :value="cardNumber"
    @input="handleInput"
    v-on="$listeners"
    v-bind="$attrs"
  )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import InputField from '../input-field'

@Component({
  model: {
    prop: 'cardNumber',
    event: 'style'
  },

  components: {
    InputField
  },

  props: {
    cardNumber: {
      type: [String, Number]
    }
  },
})
class CreditCardInput extends Vue {
  handleInput(val) {
    const length = val.length
    if (length === 4) {
      this.$emit('style', val + ' ')
    } else if (length === 5) {
      this.$emit('style', val.substr(0, 4))
    } else if (length === 9) {
      this.$emit('style', val + ' ')
    } else if (length === 10) {
      this.$emit('style', val.substr(0, 9))
    } else if (length === 14) {
      this.$emit('style', val + ' ')
    } else if (length === 15) {
      this.$emit('style', val.substr(0, 14))
    } else {
      this.$emit('style', val)
    }
  }
}

export default CreditCardInput
</script>
